exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndt[data-v-39b54b11] {\n  text-align: left;\n}\n.text-primary:hover a[data-v-39b54b11] {\n  cursor: pointer;\n  text-decoration: underline;\n}\n", ""]);
